import { createSlice } from '@reduxjs/toolkit';

// Etat d'authentification centralisé dans Redux
const initialState = {
  currentUser: null,
  roles: [],
  loading: true,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCurrentUser(state, action) {
      state.currentUser = action.payload;
      state.error = null;
    },
    clearCurrentUser(state) {
      state.currentUser = null;
      state.error = null;
    },
    setCurrentUserLoading(state, action) {
      state.loading = Boolean(action.payload);
    },
    setCurrentUserError(state, action) {
      state.error = action.payload ?? 'unknown_error';
    },
    updateUserFields(state, action) {
      if (!state.currentUser) return;
      state.currentUser = { ...state.currentUser, ...action.payload };
    },
    setRoles(state, action) {
      state.roles = Array.isArray(action.payload) ? action.payload : [];
    },
    clearRoles(state) {
      state.roles = [];
    },
  },
});

export const {
  setCurrentUser,
  clearCurrentUser,
  setCurrentUserLoading,
  setCurrentUserError,
  updateUserFields,
  setRoles,
  clearRoles,
} = authSlice.actions;

export default authSlice.reducer;
